import React from 'react';
import { formatCurrency, calculateTotalAssetsValue, calculateNetWorth } from '../gameData';
import GameNav from './GameNav';
import ShareMenu from './ShareMenu';

function Header({ player, onShowLeaderboard, onShowHowTo }) {
  const totalAssetsValue = calculateTotalAssetsValue(player);
  const dayDisplay = Math.min(player.day, player.maxDays);

  return (
    <div id="fixed-header">
      <GameNav />
      <p>
        Location: <span>{player.location}</span> |
        Day: <span>{dayDisplay}</span> / {player.maxDays} |
        Money: <span>{formatCurrency(player.money)}</span> |
        Assets: <span>{formatCurrency(totalAssetsValue)}</span> |
        Debt: <span>{formatCurrency(player.debt)}</span> |
        <strong>Net Worth: <span>
          {formatCurrency(calculateNetWorth(player))}
        </span></strong>
      </p>
      <div className="header-actions">
        <button className="header-btn howto-btn" onClick={onShowHowTo}>
          <span className="hb-icon" aria-hidden="true">❓</span>
          <span className="hb-text">How to Play</span>
        </button>
        <button className="header-btn leaderboard-btn" onClick={onShowLeaderboard}>
          <span className="hb-icon medal" aria-hidden="true">🎖️</span>
          <span className="hb-text">Leaderboard</span>
        </button>
        <ShareMenu />
      </div>
    </div>
  );
}

export default Header;
